import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import resources from './resources';
import hiLocale from './locales/hi.json';
import mrLocale from './locales/mr.json';
import teLocale from './locales/te.json';

const mergedResources = {
    ...resources,
    hi: {
        translation: {
            ...resources.hi.translation,
            ...hiLocale,
        },
    },
    mr: {
        translation: {
            ...resources.mr.translation,
            ...mrLocale,
        },
    },
    te: {
        translation: {
            ...resources.te.translation,
            ...teLocale,
        },
    },
};

i18n
    .use(initReactI18next) // Bind react-i18next to i18next
    .init({
        resources: mergedResources,
    lng: 'hi', // Default language
    fallbackLng: 'hi', // Fallback language if translation not found
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;